import Icon from '../components/Icon.vue'

Icon.register({
  'ellipsis-h': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zM432 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM80 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ellipsis-h.js
// module id = 1295
// module chunks = 0